angular.module('app.filters').filter('highFrameRate', function() {
    return function(hfr) {
        if (hfr == 'auto') return 'auto';
        return hfr ? 'enabled' : 'disabled';
    };
});


// WEBPACK FOOTER //
// ./filters/high_frame_rate.js